import { React, useEffect, useState, useRef } from 'react';
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService'
import CustomerLogin from './CustomerLogin.jsx';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import MyOrder from './MyOrder';
import ClientAccount from './ClientAccount';
import OrderHistory from './OrderHistory';
import './CustomerPortal.css';
import { CustomerProvider } from './CustomerContext';

export default function ClientPortal(props) {
    const [selectedTab, setSelectedTab] = useState('1');

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };


    return (<div className={'CustomerPortal'}>

        <TabContext value={selectedTab} >
            <TabList
                className="tabHeader"
                variant="fullWidth"
                textColor="primary"
                indicatorColor="secondary"
                onChange={handleTabChange} aria-label="Client Tabs">
                <Tab style={{ fontWeight: 'bold' }}
                    label="Orders"
                    value="1" />

                <Tab style={{ fontWeight: 'bold' }}
                    label="My Info"
                    value="2" />

                <Tab style={{ fontWeight: 'bold' }}
                    label="History"
                    value="3" />
            </TabList>

            <TabPanel value="1" style={{ padding: '10px' }}>
                <MyOrder />
            </TabPanel>
            <TabPanel value="2" style={{ padding: '5px' }}>
                <ClientAccount />
            </TabPanel>
            <TabPanel value="3" style={{ padding: '10px' }}>
                <OrderHistory />
            </TabPanel>
        </TabContext>
    </div>);
}